<template>
  <div class="home">
    <img class="btn" src="../assets/dp-btn.png" alt @click="back" />
    <img class="bg" src="../assets/longta.jpg" alt v-if="id == 1613"/>
    <img class="bg" src="../assets/kaiertup1.jpg" alt v-if="id == 1590" />
    <img class="bg" src="../assets/shuangfeng.jpg" alt v-if="id == 1647" />
    <img class="bg" src="../assets/duzhou.jpg" alt v-if="id == 1752" />
    <div class="time">
      <span>{{ date }}</span>
      <span>{{ time }}</span>
      <span>{{ day }}</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      time: "",
      day: "",
      date: "",
      id:0
    };
  },
  created(){
      this.id = sessionStorage.getItem('branchid')
    },
  methods: {
    back() {
      window.history.back();
    }
  },
  mounted() {
    let date = new Date();
    let mon = date.getMonth() + 1;
    if (mon < 10) {
      mon = "0" + mon;
    }
    let hour = date.getHours();
    let min = date.getMinutes();
    if (hour < 10) {
      hour = "0" + hour;
    }
    if (min < 10) {
      min = "0" + min;
    }
    let day = date.getDay();
    let arr = [
      "星期日",
      "星期一",
      "星期二",
      "星期三",
      "星期四",
      "星期五",
      "星期六"
    ];
    this.date =
      date.getFullYear() +
      "-" +
      mon +
      "-" +
      (date.getDate() < 10 ? "0" + date.getDate() : date.getDate());
    this.day = arr[day];
    this.time = hour + ":" + min;
    setInterval(() => {
      date = new Date();
      let mon = date.getMonth() + 1;
      if (mon < 10) {
        mon = "0" + mon;
      }
      let hour = date.getHours();
      let min = date.getMinutes();
      if (hour < 10) {
        hour = "0" + hour;
      }
      if (min < 10) {
        min = "0" + min;
      }
      let day = date.getDay();
      let arr = [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"
      ];
      this.date =
        date.getFullYear() +
        "-" +
        mon +
        "-" +
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate());
      this.day = arr[day];
      this.time = hour + ":" + min;
    }, 1000);
  }
};
</script>
<style scoped>
.home {
  position: relative;
  width: 1920px;
}
.btn {
  position: absolute;
  left: 10px;
}
.time {
  color: #fff;
  position: absolute;
  top: 20px;
  right: 20px;
  font-size: 30px;
}
span {
  margin-left: 20px;
}
</style>
